// const BASE_URL = 'http://localhost:8080';


// const BASE_URL = 'https://pscore-app-backend-node-878e41dd40dc.herokuapp.com';


// export const API_URL = (slug, type = 'users') => `${BASE_URL}/api/${type}/${slug}`;


const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const API_URL = (slug, type = 'users') => `${BASE_URL}/api/${type}/${slug}`;
